export default __webpack_public_path__ + "static/media/logoFullHalloween.4caffad1.png";